import { useBoundaryGroupsIsLoadingSelector } from '~/store/boundaryGroups/boundaryGroups.selectors';
import { useBoundaryTerritoryDetailsIsLoadingSelector } from '~/store/boundaryTerritoryDetails/boundaryTerritoryDetails.selectors';
import { useDemographicsListPremiumIsLoadingSelector } from '~/store/demographics/premiumDemographics/demographicsListPremium.selectors';
import { useIsDataLayerToolUpdatingSelector } from '~/store/frontendState/mapTools/dataLayers/dataLayers.selectors';

export const useIsDataLayersToolLoading = (): boolean => {
  const isBoundaryGroupsLoading = useBoundaryGroupsIsLoadingSelector();
  const isPremiumDemographicsLoading = useDemographicsListPremiumIsLoadingSelector();
  const isDataLayerToolUpdating = useIsDataLayerToolUpdatingSelector();
  const isActiveLayerFillDetailsLoading = useBoundaryTerritoryDetailsIsLoadingSelector();

  return isBoundaryGroupsLoading
    || isPremiumDemographicsLoading
    || isDataLayerToolUpdating
    || isActiveLayerFillDetailsLoading;
};
